/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Title_Line1Inputs */

const en_home_title_line1 = /** @type {(inputs: Home_Title_Line1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open RMF,`)
};

const fr_home_title_line1 = /** @type {(inputs: Home_Title_Line1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open RMF,`)
};

const ms_sg2_home_title_line1 = /** @type {(inputs: Home_Title_Line1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open RMF,`)
};

/**
* | output |
* | --- |
* | "Open RMF," |
*
* @param {Home_Title_Line1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const home_title_line1 = /** @type {((inputs?: Home_Title_Line1Inputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Title_Line1Inputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_title_line1(inputs)
	if (locale === "fr") return fr_home_title_line1(inputs)
	return ms_sg2_home_title_line1(inputs)
});